// extracted by mini-css-extract-plugin
export default {"root":"IconInstagram_root__Kjj6d"};